import { render } from "./MainView.vue?vue&type=template&id=2a9fbbce&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "@/styles/views/main.css?vue&type=style&index=0&id=2a9fbbce&scoped=true&lang=css"
import "./MainView.vue?vue&type=style&index=1&id=2a9fbbce&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9fbbce"]])

export default __exports__